module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/todo_lv_mobile-a06960a7fe077c554393f20767c7d240.webp";